<script>
    import Main from './layout/Main.svelte';
    import {Quotations} from "../class/business/Quotations";
    import QuotationTable from "../com/business/QuotationTable.svelte";
    import Breadcrumb from "../com/ui/Breadcrumb.svelte";
    import { t } from "../i18n";

    let quotationsPromise = Quotations.get_all();

</script>


<Main title={$t('page.home')}>


    <!-- BEGIN: Content-->

    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">

            <div class="content-header row">
                <div class="content-header-left col-12 mb-2 mt-1">
                    <div class="row breadcrumbs-top">
                        <div class="col-12">
                            <Breadcrumb path="home => {$t('breadcrumb.quotations')}"></Breadcrumb>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-body">

                <section class="invoice-list-wrapper">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col">
                                <div>

                                    {#await quotationsPromise}
                                        {$t('home.loading')}
                                    {:then data}
                                        <QuotationTable {data}></QuotationTable>
                                    {:catch err}
                                        {$t('home.error')} {err}
                                    {/await}

                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <!-- END: Content-->



</Main>


